import React, { useState } from 'react';
import { message, Card, Layout, Modal } from "antd";
import { MDBBox, MDBRow, MDBCol, MDBAlert } from "mdbreact";
import { Text } from "react-font";
import Firebase from "../../Firebase/Firebase";
import {
	Button,
	CogIcon,
	EyeOpenIcon, Heading, Pane, SideSheet,
} from "evergreen-ui";
import LanguageLayout from "./ModalLayouts/LanguageLayout";
import LanguageActionLayout from "./ModalActionLayout/LanguageActionLayout";
import CountriesLayout from "./ModalLayouts/CountriesLayout";
import CountriesActionLayout from "./ModalActionLayout/CountriesActionLayout";
import UserRolesLayout from "./ModalLayouts/UserRolesLayout";
import UserRolesActionLayout from "./ModalActionLayout/UserRolesActionLayout";
import InitiativeLayout from "./ModalLayouts/InitiativeLayout";
import VolunteerLayout from "./ModalLayouts/VolunteerLayout";
import InitiativeActionLayout from "./ModalActionLayout/InitiativeActionLayout";
import VolunteerActionLayout from "./ModalActionLayout/VolunteerActionLayout";
import AdminSettingsLayout from "./ModalLayouts/AdminSettingsLayout";
import OrganizationsLayout from "./ModalLayouts/OrganizationsLayout";
import CommunitiesLayout from "./ModalLayouts/CommunitiesLayout";
import OrganizationsActionLayout from "./ModalActionLayout/OrganizationsActionLayout";
import CommunitiesActionLayout from "./ModalActionLayout/CommunitiesActionLayout";
import CategoriesLayout from "./ModalLayouts/CategoriesLayout";
import CategoriesActionLayout from "./ModalActionLayout/CategoriesActionLayout";
import SubCategoriesLayout from "./ModalLayouts/SubCategoryLayout";
import SubCategoriesActionLayout from "./ModalActionLayout/SubCategoryActionLayout";
import InitiativeProgramActionLayout from "./ModalActionLayout/InitiativeProgramActionLayout";
import InitiativeProgramLayout from "./ModalLayouts/InitiativeProgramLayout";
import ZoneLayout from "./ModalLayouts/ZoneLayout";
import ZoneActionLayout from "./ModalActionLayout/ZoneActionLayout";
import DistrictsLayout from "./ModalLayouts/DistrictsLayout";
import DistrictsActionLayout from "./ModalActionLayout/DistrictsActionLayout";
import { useListVals } from "../../Firebase/databaseHooks";
import { invalidateDemoData } from "../../Firebase/databaseHooks";
import FireFetch from "../../Firebase/FireFetch";
import { getDatabase, ref, remove, set } from "firebase/database";
import GroupTypeLayout from "./ModalLayouts/GroupTypeLayout";
import LessonTypeLayout from "./ModalLayouts/LessonTypesLayout";
import GroupTypeActionLayout from "./ModalActionLayout/GroupTypeActionLayout";
import ProvincesActionLayout from './ModalActionLayout/ProvinceActionLayout';
import ProvincesLayout from './ModalLayouts/ProvinceLayout';
import EmailTemplatesLayout from "./ModalLayouts/EmailTemplatesLayout";
import UiStringsLayout from "./ModalLayouts/UiStringsLayout";
import { useAuth } from "../../AuthContext/AuthContext";


var db = getDatabase(Firebase);
const Settings = () => {
	const { canAccessModule } = useAuth();
	const canCreateAdmin = canAccessModule("ADMIN_CONFIGS", "create");
	const canUpdateAdmin = canAccessModule("ADMIN_CONFIGS", "update");
	const canDeleteAdmin = canAccessModule("ADMIN_CONFIGS", "delete");

	const [checkedData, setCheckedData] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [title, setTitle] = useState("");
	const [layout, setLayout] = useState(null);
	const [showActionModal, setShowActionModal] = useState(false);
	const [actionLayout, setActionLayout] = useState(null);
	const [initiativeTypes] = useListVals(ref(db, "talmidsdb/initiativeTypes"));

	const Save = (endPoint, objectID, object) => {
		if (!canCreateAdmin) {
			message.error("You do not have permission to create admin configuration records.");
			return;
		}

		set(ref(db, "talmidsdb/" + endPoint + "/" + objectID), object)
			.then(() => {
				invalidateDemoData([
					"talmidsdb/" + endPoint,
					"talmidsdb/" + endPoint + "/" + objectID,
				]);
				FireFetch.addLog(endPoint, objectID, "Create");
				message.success(endPoint + ": added successfully");

			})
			.catch((error) => {
				message.error("Unable to add due to an error : " + error.message);
			})
	};

	const Delete = (endPoint, objectID) => {
		if (!canDeleteAdmin) {
			message.error("You do not have permission to delete admin configuration records.");
			return;
		}

		remove(ref(db, "talmidsdb/" + endPoint + "/" + objectID)).then(() => {
			invalidateDemoData([
				"talmidsdb/" + endPoint,
				"talmidsdb/" + endPoint + "/" + objectID,
			]);
			FireFetch.addLog(endPoint, objectID, "Delete");
			message.success(endPoint + ": deleted successfully");
		})
			.catch((error) => {
				message.error("Unable to delete due to an error : " + error.message);
			})
	};

	const handleMessageBack = (category, mensaje, id) => {
		console.log(mensaje);
		console.log(category);
		if (category === "languages") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<LanguageActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true)

			} else if (mensaje === "delete") {
				Delete("languages", id);
			}

		} else if (category === "countries") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<CountriesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("countries", id);
			}

		}
		else if (category === "province") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<ProvincesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("province", id);
			}
		}
		else if (category === "zones") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<ZoneActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("zones", id);
			}

		} else if (category === "userRoles") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<UserRolesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("userRoles", id);
			}

		} else if (category === "volunteers") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<VolunteerActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("volunteerTypes", id);
			}
		} else if (category === "initiatives" || category === "Initiatives") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<InitiativeActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("initiatives", id);
			}
		} else if (category === "initiativeTypes") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<InitiativeProgramActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("initiativeTypes", id);
			}
		} else if (category === "organisations") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<OrganizationsActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("organisations", id);
			}
		} else if (category === "communities") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<CommunitiesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("communities", id);
			}
		} else if (category === "categories") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<CategoriesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("categories", id);
			}
		} else if (category === "subcategories") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<SubCategoriesActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("subCategories", id);
			}
		} else if (category === "district") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<DistrictsActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("district", id);
			}
		} else if (category === "groupTypes") {
			if (mensaje === "create") {
				if (!canCreateAdmin) {
					message.error("You do not have permission to create admin configuration records.");
					return;
				}

				setActionLayout(<GroupTypeActionLayout createCallback={handleCreateCallBack} canCreate={canCreateAdmin} />);
				setShowActionModal(true);
			} else if (mensaje === "delete") {
				Delete("groupTypes", id);
			}
		}
	}

	const handleCreateCallBack = (category, objectID, object) => {
		if (category === "languages") {
			Save(category, objectID, object);
			setShowActionModal(false); handleLanguages();
			setActionLayout(null);
		} else if (category === "countries") {
			Save(category, objectID, object);
			setShowActionModal(false); handleCountries();
			setActionLayout(null);
		} else if (category === "province") {
			Save(category, objectID, object);
			setShowActionModal(false); handleProvince();
			setActionLayout(null);
		}
		else if (category === "zones") {
			Save(category, objectID, object);
			setShowActionModal(false); handleZones();
			setActionLayout(null);
		} else if (category === "district") {
			Save(category, objectID, object);
			setShowActionModal(false); handleDistricts();
			setActionLayout(null);
		} else if (category === "userRoles") {
			Save(category, objectID, object);
			setShowActionModal(false); handleRoles();
			setActionLayout(null);
		} else if (category === "initiatives" || category === "Initiatives") {
			Save(category, objectID, object);
			setShowActionModal(false); handleInitiatives();
			setActionLayout(null);
		} else if (category === "initiativeTypes") {
			if ((initiativeTypes || []).some(e => e.code === object.code)) {
				setShowActionModal(false);
				setActionLayout(null);
				message.error("An initiative sector with the same code already exists");

			} else {
				Save(category, objectID, object);
				setShowActionModal(false); handlePrograms();
				setActionLayout(null);
			}
		} else if (category === "volunteerTypes") {
			Save(category, objectID, object);
			setShowActionModal(false); handleVolunteer();
			setActionLayout(null);
		} else if (category === "organisations") {
			Save(category, objectID, object);
			setShowActionModal(false); handleOrgs();
			setActionLayout(null);
		} else if (category === "communities") {
			Save(category, objectID, object);
			setShowActionModal(false); handleCommunities();
			setActionLayout(null);
		} else if (category === "categories") {
			Save(category, objectID, object);
			setShowActionModal(false); handleCategories();
			setActionLayout(null);
		} else if (category === "subCategories") {
			Save(category, objectID, object);
			setShowActionModal(false); handleSubs();
			setActionLayout(null);
		} else if (category === "all") {
			setShowActionModal(false); setActionLayout(null);
		} else if (category === "groupTypes") {
			Save(category, objectID, object);
			setShowActionModal(false); handleGroupType();
			setActionLayout(null);
		}
	}


	const handleVolunteer = () => {
		setTitle("Volunteer Types");
		setLayout(<VolunteerLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleInitiatives = () => {
		setTitle("Initiatives");
		setLayout(<InitiativeLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleLanguages = () => {
		setLayout(<LanguageLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Languages");
		setShowModal(true);
	}

	const handleCountries = () => {
		setLayout(<CountriesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Countries");
		setShowModal(true);
	}

	const handleProvince = () => {
		setLayout(<ProvincesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Provinces");
		setShowModal(true);
	}

	const handleCommunities = () => {
		setLayout(<CommunitiesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Communities");
		setShowModal(true);
	}

	const handleOrgs = () => {
		setLayout(<OrganizationsLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("organisations");
		setShowModal(true);
	}

	const handleRoles = () => {
		setLayout(<UserRolesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />);
		setTitle("User Roles");
		setShowModal(true);
	}
	const handleSettings = () => {
		setLayout(<AdminSettingsLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />);
		setTitle("Admin Settings");
		setShowModal(true);
	}
	const handleSubs = () => {
		setLayout(<SubCategoriesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Sub-Categories");
		setShowModal(true);
	}

	const handleCategories = () => {
		setLayout(<CategoriesLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setTitle("Categories");
		setShowModal(true);
	}

	const handlePrograms = () => {
		setTitle("Initiative Sector");
		setLayout(<InitiativeProgramLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleZones = () => {
		setTitle("Zones");
		setLayout(<ZoneLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleDistricts = () => {
		setTitle("Districts");
		setLayout(<DistrictsLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleGroupType = () => {
		setTitle("Group Type");
		setLayout(<GroupTypeLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}
	const handleLessonType = () => {
		setTitle("Lesson Type");
		setLayout(<LessonTypeLayout messageBack={handleMessageBack} canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />)
		setShowModal(true);
	}

	const handleEmailTemplates = () => {
		setTitle("Email Templates");
		setLayout(<EmailTemplatesLayout canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />);
		setShowModal(true);
	}

	const handleUiStrings = () => {
		setTitle("App Languages");
		setLayout(<UiStringsLayout canCreate={canCreateAdmin} canUpdate={canUpdateAdmin} canDelete={canDeleteAdmin} />);
		setShowModal(true);
	}

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<Modal
				title={`New ${title}`}
				visible={showActionModal}
				onOk={() => { setShowActionModal(false) }}
				onCancel={() => { setShowActionModal(false) }}
				footer={false}
				width="400px"
				isShown={showActionModal}
				onCloseComplete={() => { setShowActionModal(false) }}
			>
				{actionLayout}
			</Modal>
			<SideSheet
				isShown={showModal}
				width={window.innerWidth - 300}
				title={title}
				topOffset="10px"
				onCloseComplete={() => { setShowModal(false); setLoading(false) }}
				containerProps={{
					display: 'flex',
					flex: '1',
					flexDirection: 'column',
					backgroundColor: 'transparent'
				}}
			>
				<Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
					<Pane padding={16}>
						<Heading size={600}>{title}</Heading>
					</Pane>
				</Pane>
				<Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
					<Card
						backgroundColor="white"
						elevation={0}
						display="flex"
						alignItems="center"
						justifyContent="center"
					>
						<MDBBox>
							<MDBRow>
								<MDBCol className="d-flex flex-column">
									{layout}
								</MDBCol>
							</MDBRow>
						</MDBBox>
					</Card>
				</Pane>
			</SideSheet >
			<MDBRow className="w-100">
				<MDBCol className="w-100">
					<MDBRow>
						<MDBCol md={12}>
							<Card className="w-100 px-3">
								<MDBRow>
									<MDBCol md={10}>
										<div className="text-left">
											<div className="d-block">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														Admin Configurations
													</Text>
												</h5>
											</div>
										</div>
									</MDBCol>
									<MDBCol>
										<MDBRow>
											<Button appearance="primary" className="ml-2" onClick={() => { setLayout(null); handleSettings(); }} iconAfter={CogIcon}>
												Admin Settings
											</Button>
										</MDBRow>
									</MDBCol>
								</MDBRow>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow className="mt-4">
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Worker Types</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Worker type options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleVolunteer(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Initiatives</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Initiative options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleInitiatives(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Organizations</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Organizations</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleOrgs(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Communities</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Community options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleCommunities(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Countries</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Countries options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleCountries(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Languages</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Languages options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleLanguages(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Provinces</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove province options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleProvince(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>User Roles</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove User Role Options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleRoles(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Districts</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Districts</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleDistricts(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Sub-Categories</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>View & Add SubCategories</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleSubs(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Zones</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Zones</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleZones(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Categories</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Lesson Categories options</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleCategories(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Group Types</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Group Types</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleGroupType(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Initiative Sector</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Initiative Sector</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handlePrograms(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Lesson Types</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add/Remove Lesson Types</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleLessonType(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>Email Templates</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Add or edit welcome and password reset email templates by language</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleEmailTemplates(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
					</MDBRow>
					<MDBRow>
						<MDBCol>
							<Card title={<span style={{ color: '#51195D' }}>App Language</span>} className="my-2" bordered={false}>
								<Text className="d-block h6 mb-2" family="Nunito" style={{ color: "#51195D" }}>Master list of app interface text that every language is translated from</Text>
								<Button appearance="primary" className="d-block d-flex justify-content-center" onClick={() => { setLayout(null); handleUiStrings(); }} iconAfter={EyeOpenIcon}>
									view
								</Button>
							</Card>
						</MDBCol>
						<MDBCol />
					</MDBRow>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default Settings;
